"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.defineVehiclePanelFromPassengerNbr = exports.defineEngineTypeFromExternalVehicleAPIEnergie = void 0;
var defineEngineTypeFromExternalVehicleAPIEnergie = function (energie) {
    if (energie === 'ELECTRIC') {
        return 'ELECTRIC';
    }
    else if (energie.includes('ELEC HNR')) {
        return 'SIMPLE_HYBRID';
    }
    else if (energie.includes('ELEC HR')) {
        return 'PLUGIN_HYBRID';
    }
    else if (energie == 'GAZOLE') {
        return 'DIESEL';
    }
    else {
        return 'GASOLINE';
    }
};
exports.defineEngineTypeFromExternalVehicleAPIEnergie = defineEngineTypeFromExternalVehicleAPIEnergie;
var defineVehiclePanelFromPassengerNbr = function (passengerNumber) {
    if (passengerNumber === 1) {
        return 'MOTO';
    }
    else if (passengerNumber <= 4) {
        return 'BERLINE';
    }
    else {
        return 'VAN';
    }
};
exports.defineVehiclePanelFromPassengerNbr = defineVehiclePanelFromPassengerNbr;
